// The three figures every part of the section quotes: how many participants the
// filters leave in scope, and how that splits between the two tables.
//
// All three are read from the load that built the lists, never from the latest
// response. A search is answered with the totals for what it matched — search
// "ana" out of seven participants and both lists come back saying two — but the
// badges and the footer are talking about the whole set, so a searched figure
// would have the sections reading "2 of 2" and promising to compare two people
// when Apply would still compare five.
//
// Only the not-compared response carries `totalLeaders`, so that side is taken
// from there and the compared side is what's left of the grand total. The live
// totals are the fallback for a response that didn't report the remembered ones
// — wrong under a search, but the alternative is showing nothing at all.
const firstNumber = (...values) => {
    const found = values.find((value) => value != null);
    return found != null ? found : 0;
};

export const selectTrendTotals = (state) => {
    const { fetchProjectComparisonApi, fetchProjectNotComparedApi } = state.BenchmarkFilteringReducer;

    // Both lists are told the same grand total, so either one answers for it.
    const totalCount = firstNumber(
        fetchProjectComparisonApi.baseTotalAllLeaders,
        fetchProjectNotComparedApi.baseTotalAllLeaders,
        fetchProjectNotComparedApi.totalAllLeaders,
        fetchProjectComparisonApi.totalAllLeaders,
    );

    const notComparedCount = firstNumber(
        fetchProjectNotComparedApi.baseListTotal,
        fetchProjectNotComparedApi.totalLeaders,
    );

    // What each list holds right now, search included — the whole list while the
    // box is empty. This is the pair the section badges count, so paging through
    // a list doesn't change what it says it holds: 25 compared participants read
    // as "25 of 25" from the first page on, not "10 of 25".
    //
    // These come from the live response, which does follow the search, and the
    // split is made the same way: the not-compared response counts itself, the
    // compared side is what's left of that response's grand total. A list is
    // counted by its loaded rows only when neither total was reported.
    const notComparedListTotal = firstNumber(
        fetchProjectNotComparedApi.totalLeaders,
        (fetchProjectNotComparedApi.data || []).length,
    );
    const comparedListTotal = fetchProjectComparisonApi.totalAllLeaders
        ? Math.max(fetchProjectComparisonApi.totalAllLeaders - notComparedListTotal, 0)
        : (fetchProjectComparisonApi.data || []).length;

    return {
        totalCount,
        notComparedCount,
        comparedCount: Math.max(totalCount - notComparedCount, 0),
        comparedListTotal,
        notComparedListTotal,
    };
};
